























import Vue from 'vue';
import customerClient from '../../apis';
import customerVuex from '../../vuex/common';

const searchFields: string[] = [];

export default Vue.extend({
  mixins: [customerVuex],
  data() {
    return {
      visible: false,
      searchFields,
    };
  },
  methods: {
    loadSearchFields() {
      customerClient.getSearchFields().success((r) => {
        const sfs = r.searchFields.includes('openid') ? r.searchFields : [...r.searchFields, 'openid']
        this.$store.commit('SET_SEARCH_FIELDS', sfs);
        this.searchFields = sfs;
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    cancel() {
      this.visible = false;
      this.searchFields = this.customerState.searchFields;
    },
    confirm() {
      if (this.searchFields.length < 1) {
        this.$Message.warning('请至少选择一个可搜索字段');
      } else {
        customerClient.saveSearchFields({
          searchFields: this.searchFields,
        }).success((r) => {
          this.$Message.success('设置成功');
          this.visible = false;
          this.$store.commit('SET_SEARCH_FIELDS', this.searchFields);
        }).failure((code: string, msg?: string) => {
          this.$Message.error(msg);
        }).error((e) => {
          this.$Message.error(e.toString());
        });
      }
    },
  },
  mounted() {
    this.loadSearchFields();
  },
});
